import { useQuery } from "@tanstack/react-query";
import { InsurancePayerControllerApi } from "../services";
import { DGT_Pagination, getConfigObject, useBaseContent } from "../utils/utils";

interface Props {
  searchKey?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
  pagination?: DGT_Pagination;
}

type OptionData = {
  payerId: string;
  payerName: string;
};

/**
 *
 * Lists only active, non-archived payers for selection dropdowns.
 *
 * @author Shrinivas Mandhare
 */
export const useInsurancePayerList = ({
  searchKey,
  xTENANTID,
  enabled,
  pagination,
}: Props): useBaseContent<OptionData> =>
  useQuery({
    queryKey: [
      "insurance-payer-list",
      xTENANTID,
      searchKey,
      pagination?.page,
      pagination?.pageSize,
    ],
    refetchOnWindowFocus: false,
    enabled: enabled ?? true,
    queryFn: async () => {
      const response = await new InsurancePayerControllerApi(
        getConfigObject()
      ).getInsurancePayersByStatus(
        pagination?.page, // page
        pagination?.pageSize ?? 10, // size
        undefined, // sortBy
        undefined, // sortDirection
        searchKey, // searchString
        true, // active
        false, // archive
        undefined, // payerType
        xTENANTID // xTENANTID
      );
      return response?.data;
    },
  });
